//@flow
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Modal from '../../../../../../../elements/Modal/Modal';

import style from './InternmentPermitModal.scss';
import buttonStyle from '../../../../../../../assets/styles/button.scss';

type Props = {
  isOpen?: boolean;
  handleClose: () => void;
  isTraveler?: boolean;
};

export default function InternmentPermitModal(props: Props) {
  const {isOpen, handleClose, isTraveler = true} = props;

  const travelersText = <div className={style.textContent}>
    <span>
      Los envíos con viajeros se realizan con los viajeros registrados en nuestra comunidad que tienen espacio libre en su equipaje.
      De esta forma, podrás ahorrar mucho en envío e impuestos.
    </span>
    <br />
    <span>
      Algunos productos prohibidos traer por viajeros: Autopartes, paquetes de más de 60x40x40cm o de más de 6kg, 
      productos médicos, armas y réplicas, entre otros. 
      <br />
      Contáctanos parás información.
    </span>
  </div>;

  const commercialCargoText = <div className={style.textContent}>
    <span>
      Los envíos por carga comercial se realizan a través de nuestro couriers autorizados para 
      hacer envíos por nuestra plataforma y re permite comprar productos de gran tamño y peso.
    </span>
    <br />
    <span>
      Algunos productos prohibidos traer por carga:
      Autopartes usadas, artículos médicos, vitaminas, maquillaje, armas o réplicas, entre otros.   
      <br />
      Contáctanos para más información.
    </span>
  </div>;

  return (
    <Modal key="internmentPermitModal"
           open={isOpen}
           width={450}
           height={350}
           handleClose={() => handleClose()}>
      <div className={style.topWrap}>
        <div className={style.textWrap}>
          <p className={style.title}>
            {isTraveler ? 'Envíos con viajeros' :'Envíos por carga'}
          </p>
        </div>
      </div>
      <div className={style.contentWrap}>
        {isTraveler ? travelersText : commercialCargoText}

        <div className={classNames(buttonStyle.btn, 
                                style.buttonWrap)}>
         <button onClick={() => handleClose()}>Continuar</button>
        </div>
      </div>
    </Modal>
  );
}

InternmentPermitModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  isTraveler: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/InternmentPermitModal/InternmentPermitModal.jsx